
import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { NGX_LOADING_BAR_IGNORED } from '@ngx-loading-bar/http-client';
import { TranslateLoader } from "@ngx-translate/core";
import { catchError, Observable, of } from 'rxjs';
import { LoggerService } from "@teammood/shared/util/logger";

@Injectable()
export class TmTranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient, private logger: LoggerService) {}

  /**
   * Gets the translations from the server
   */
  // eslint-disable-next-line @typescript-eslint/ban-types
  public getTranslation(lang: string): Observable<Object> {
    return this.http.get(`/api/i18n/messages?lang=${lang}`,
      {
        //loading translation is done in background and should not trigger loading bar
        context: new HttpContext().set(NGX_LOADING_BAR_IGNORED, true), 
      }
    ).pipe(
        catchError(err => {
          this.logger.error('unable to get i18n messages', err);
          return of({})
        })
    );
  }
}